/* src/app/dynamic-forms/form-view/form-view-input/form-view-input.component.css */
.mat-mdc-form-field {
  display: inline;
}
/*# sourceMappingURL=form-view-input.component.css.map */
